export enum AvResult {
	CLEAN = 'clean',
}
